export default __webpack_public_path__ + "static/media/image.zircon-host.c7f04f5f.png";